export const environment = {
	production: false,
	apiUrl: "https://europe-west1-zanga-hr-dev.cloudfunctions.net",
	region: "europe-west1",
	APP_URL: "https://dev.partners.zangametrics.com",
	MEMBERS_APP_URL: "https://dev.members.zangametrics.com",
	firebase: {
		apiKey: "AIzaSyAAkYEz514vuWpEj0s21bLKbXObOrTLVss",
		authDomain: "zanga-hr-dev.firebaseapp.com",
		projectId: "zanga-hr-dev",
		storageBucket: "zanga-hr-dev.firebasestorage.app",
		messagingSenderId: "752686448822",
		appId: "1:752686448822:web:86541f08922d32baaf6617",
	},
	recaptcha: {
		siteKey: "6Lfp9W0rAAAAAI45JkTbITfhk_WOFDFtvyws1tUI",
		version: "enterprise",
	},
};
